
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/doors",
      function () {
        return require("private-next-pages/alu/doors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/doors"])
      });
    }
  